import * as React from "react"
const SvgSend = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path d="m19.8 13.64-15.4 6.5a.99.99 0 0 1-.95-.088Q3 19.764 3 19.214v-13q0-.55.45-.837a.99.99 0 0 1 .95-.088l15.4 6.5q.625.276.625.925 0 .65-.625.925ZM5 17.713l11.85-5-11.85-5v3.5l6 1.5-6 1.5z" />
  </svg>
)
export default SvgSend
